/* src/modules/course_approvals/cards/AddCourses/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, map } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Chip,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';

import { Add, Search } from '@material-ui/icons';
import { Expand, PaperHeader } from '../../../../app/components';
import styles from './styles';

import { getSelectedName, getTutorUniversities, getSearchResult } from '../../selectors';
import { selectCourseApprovalTutorUniversity, addCoursesToTutor } from '../../actions';
import { searchCourses } from '../../../courses/actions';
import { parseCourseString } from '../../../../util';
import { loadTexts } from '../../../../config/texts';

import AddCoursesComponent from '../../../../app/components/user/AddCourses';
const TEXT_KEY = 'course_approval';

class AddCourses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coursesString: '',
      formattingError: '',
      found: '',
      notFound: '',
      courses: [],
      openSelect: false,
      texts: loadTexts(TEXT_KEY, props.locale)
    };
  }

  _onChangeUniversity = event => {
    this.props.selectCourseApprovalTutorUniversity(event.target.value);
  }

  _onPressSearch = async () => {
    const { coursesString } = this.state;
    const courses = parseCourseString(coursesString);
    if (~courses.indexOf(false)) {
      this.setState({ formattingError: true, found: '', notFound: '', courses: [] });
      return;
    }

    this.setState({ formattingError: false });

    await this.props.searchCourses({
      university: this.props.selectedUniversity,
      input: courses,
    });

    this.setState(this.props.searchedCourses);
  }

  _onChangeCourses = event => {
    this.setState({ coursesString: event.target.value });
  }

  _onPressAdd = async () => {
    await this.props.addCoursesToTutor({
      tutor: this.props.selectedTutor,
      university: this.props.selectedUniversity,
      courses: this.state.courses.map(c => c._id),
    });

    this.setState({ courses: [], found: '', notFound: '', coursesString: '' });
  }

  renderUniversitySelect(classes) {
    const { universities, selectedUniversity } = this.props;
    const { texts } = this.state;
    return (
      <FormControl className={classes.form}>
        <InputLabel htmlFor="add_courses_university">
          {texts.fields.institution}
        </InputLabel>
        <Select
          value={selectedUniversity}
          onChange={this._onChangeUniversity}
          input={<Input name="add_courses_university" id="add_courses_university" />}
        >
          {universities.map(u => (
            <MenuItem key={u.value} value={u.value}>
              {u.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderInstructions(classes) {
    const { texts: { instruction } } = this.state;
    return (
      <Expand text="Expand to see format for inputting courses">
        <Typography variant="body2" className={classes.instructions}>
          {`${instruction.format}:\n`}
        </Typography>
        <Typography variant="body1" className={classes.instructions}>
          {instruction.example}
        </Typography>
        <div style={{ height: 12 }} />
        <Typography variant="body2" className={classes.instructions}>
          {`${instruction.example_title}:`}
        </Typography>
        <Typography variant="body1" className={classes.instructions}>
          {'MATH|133;COMP|202&250&273'}
        </Typography>
      </Expand>
    );
  }

  renderCoursesInput(classes) {
    const { texts } = this.state;
    return (
      <div>
        <Button
          color="primary"
          variant="raised"
          onClick={() => this.setState({ openSelect: true })}
          style={{ width: '100%', marginBottom: 8 }}
          disabled={this.props.name === 'Select a tutor' || !this.props.selectedUniversity}
        >
          {texts.button_text.search_course}
        </Button>
        {this.state.courses.map(course => (
          <Chip
            key={course._id}
            size="small"
            label={course.code}
            style={{ marginBottom: 8, marginRight: 8 }}
            onDelete={() => this.setState({ courses: this.state.courses.filter(c => c._id !== course._id )})}
          />
        ))}
        <AddCoursesComponent
          open={this.state.openSelect}
          onClose={() => this.setState({ openSelect: false })}
          onSelect={item => {
            this.setState(prev => {
              if (!prev.courses.find(c => c._id === item._id))
                return { courses: [...prev.courses, item] };
              return { courses: prev.courses.filter(c => c._id !== item._id) };
            });
          }}
          selected={this.state.courses}
          selectedUniversity={this.props.selectedUniversity}
        />
      </div>
    );
    /*
    return (
      <TextField
        id="courses"
        className={classes.coursesInput}
        label="Courses"
        InputLabelProps={{ shrink: true }}
        value={this.state.coursesString}
        onChange={this._onChangeCourses}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button
                className={classes.adornment}
                aria-label="Parse Course String"
                onClick={this._onPressSearch}
                color="primary"
                variant="outlined"
                size="small"
              >
                <Search className={classes.alarmIcon} />
                {'Search'}
              </Button>
            </InputAdornment>
          ),
        }}
      />
    );
    */
  }

  renderSearchResults() {
    const { found, notFound, texts: { instruction } } = this.state;
    return (
      <React.Fragment>
        {found && (
          <Typography>
            {`${instruction.courses_to_add}: ${found}`}
          </Typography>
        )}
        {notFound && (
          <Typography color="secondary">
            {`${instruction.not_found}: ${notFound}`}
          </Typography>
        )}
      </React.Fragment>
    );
  }

  renderButton(classes) {
    const { texts: { button_text } } = this.state;
    return (
      <div className={classes.buttonContainer}>
        <Button
          disabled={isEmpty(this.state.courses) || this.props.selectedUniversity === ''}
          color="primary"
          variant="raised"
          onClick={this._onPressAdd}
        >
          <Add className={classes.alarmIcon} />
          {button_text.add_course}
        </Button>
      </div>
    );
  }

  render() {
    const { classes, name } = this.props;
    const { formattingError, texts } = this.state;
    return (
      <Paper className={classes.paper}>
        <div className={classes.padding}>
          <PaperHeader
            noPadding
            text={name === texts.labels.select_tutor ? name : `${texts.labels.courses_to_add} ${name}`}
          />
          {this.renderUniversitySelect(classes)}
        </div>
        {/*this.renderInstructions(classes)*/}
        <div className={classes.padding}>
          {this.renderCoursesInput(classes)}
          {formattingError && (
            <Typography color="secondary">
              {texts.labels.error}
            </Typography>
          )}
          {this.renderSearchResults()}
          {this.renderButton(classes)}
        </div>
      </Paper>
    );
  }
}

AddCourses.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  universities: PropTypes.array.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectCourseApprovalTutorUniversity: PropTypes.func.isRequired,
  searchCourses: PropTypes.func.isRequired,
  searchedCourses: PropTypes.object.isRequired,
  selectedTutor: PropTypes.string.isRequired,
  addCoursesToTutor: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  name: getSelectedName(state),
  universities: getTutorUniversities(state),
  selectedTutor: state.courseApprovals.main.selected,
  selectedUniversity: state.courseApprovals.main.selectedUniversity,
  searchedCourses: getSearchResult(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  selectCourseApprovalTutorUniversity:
    params => dispatch(selectCourseApprovalTutorUniversity(params)),
  searchCourses: params => dispatch(searchCourses(params)()),
  addCoursesToTutor: params => dispatch(addCoursesToTutor(params)()),
});

export default compose(
  withStyles(styles, { name: 'AddCourses' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AddCourses);



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/AddCourses/index.js